export const DEFAULT_STATE_COLOR = '#DDE3E8'; // Twilight

export const STATES_LAYER_ID = 'states-fill';
export const STATES_BORDERS_LAYER_ID = 'states-borders';

export const MAP_PADDING_PIXELS = 20;

/**
 * Base color for state visualization (Fishbrain blue)
 * Opacity will vary based on relative catch percentage
 */
export const STATE_BASE_COLOR = '#006694'; // rgb(0, 102, 148)
export const STATE_BASE_COLOR_RGB = { r: 0, g: 102, b: 148 };

/**
 * Opacity range for state colors
 * Min opacity for states with very few catches, max for states with most catches
 */
export const MIN_OPACITY = 0.15;
export const MAX_OPACITY = 1.0;

/**
 * Opacity multiplier for scaling
 * Higher values make colors reach maximum opacity faster
 * (e.g., 10 means full opacity at ~10% of data range)
 */
export const OPACITY_MULTIPLIER = 10;
